import React, { Component } from "react";
 
class Welcome extends Component {
  render() {
    return (
      <div>
        <h4>Welcome</h4>
        <p>This web application was written with React using primarily Material UI for the visual components. Please make a selection with the menu to explore the application.</p>
      </div>
    );
  }
}
 
export default Welcome;


// WEBPACK FOOTER //
// ./src/components/Welcome.js